<template>
  <div class="setting_basiceInfo">
    <comm_action_bar>
      <el-tabs v-model="activeName" @tab-click="handleClick" class="el_tabs_style">
        <el-tab-pane label="基础信息" name="first">
        </el-tab-pane>
        <el-tab-pane label="密码设置" name="second">
        </el-tab-pane>
        <el-tab-pane label="我的权限" name="third">
        </el-tab-pane>
        <el-tab-pane label="登录信息" name="five">
        </el-tab-pane>
      </el-tabs>
    </comm_action_bar>
    <comm_main overflow="auto">
      <self_setting_basiceInfo v-if="activeName == 'first'"></self_setting_basiceInfo>
      <self_password_setting v-if="activeName == 'second'"></self_password_setting >
      <self_my_permission v-if="activeName == 'third'"></self_my_permission >
      <login_info v-if="activeName == 'five'"></login_info>
    </comm_main>
  </div>
</template>
<script>
  import self_setting_basiceInfo from './basic_information/basiceInfo'
  import self_password_setting from './basic_information/password_setting'
  import self_my_permission from './basic_information/myPermission'
  // import self_tea_patriarch from './basic_information/binding_children'
  // import self_binding_parents from './basic_information/binding_parents'
  import login_info from './basic_information/login_info'
  export default {
    components: {
      self_setting_basiceInfo,
      self_password_setting,
      self_my_permission,
      // self_tea_patriarch,
      // self_binding_parents,
      login_info,
    },
    data() {
      return {
        roleTea:'',
        type:'teacher',
        activeName: 'first',
        status:true,
        info:'',
      };
    },
    methods: {
      handleClick(tab, event) {
        if (tab.index<3){
          this.status=true;
        }else {
          this.status=false;
        }
      }
    },
    mounted() {
    }

  }
</script>
<style>
  .leftNavFrame .setting_basiceInfo {margin-top:-20px;}
  .leftNavFrame .setting_basiceInfo>.comm_action_bar { margin-left:-20px; margin-right:-20px;}
  .topNavFrame .setting_basiceInfo .comm_action_bar { margin-bottom:0;}
  .leftNavFrame .el_tabs_style .el-tabs__nav-wrap::after {display: none;}

  .el_tabs_style .el-tabs__header{ margin: 0px; }
</style>



// WEBPACK FOOTER //
// src/components/setting/list.vue